module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "drop"
  }, [_c('div', {
    staticClass: "drop-zone",
    style: (_vm.dropStyle),
    on: {
      "drop": function($event) {
        $event.preventDefault();
        return _vm.fileDropped.apply(null, arguments)
      },
      "dragover": function($event) {
        $event.preventDefault();
        return _vm.fileOver.apply(null, arguments)
      },
      "dragleave": _vm.fileLeave
    }
  }, [(!_vm.showImage) ? _c('div', {
    staticClass: "plus-sign"
  }, [_vm._v(_vm._s(_vm.loadPercent))]) : _vm._e(), _vm._v(" "), (_vm.showImage) ? _c('div', {
    staticClass: "image",
    style: (_vm.imageStyle)
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "drop__label"
  }, [_vm._v("\n  " + _vm._s(_vm.label) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-447fd5fd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DropZone.vue
// module id = 241
// module chunks = 1